import { createIcon } from "@chakra-ui/react";

export const Cross = createIcon({
  displayName: "Cross",
  viewBox: "0 0 24 24",
  d: "M12 0a12 12 0 1 1 0 24 12 12 0 0 1 0-24zM8.203 15.797c.44.44 1.153.44 1.59 0l2.202-2.203 2.203 2.203a1.125 1.125 0 0 0 1.59-1.59l-2.204-2.202 2.204-2.203a1.125 1.125 0 0 0-1.59-1.59l-2.203 2.204-2.203-2.204a1.125 1.125 0 0 0-1.59 1.59l2.204 2.203-2.203 2.203a1.12 1.12 0 0 0 0 1.589z",
  defaultProps: {
    "aria-label": "A cross shape within a circle"
  }
});

export default Cross;
